import * as React from 'react';
import LoaderIcon from '../../../../common/components/loader/LoaderIcon';
import {HISTORY_EXPORT_MODAL} from '../../constants/LabelConstants';
import {ApprovedApplicationsExportConfirmProps} from '../../types/containers';

class ApprovedApplicationsHistoryExportConfirmView
    extends React.Component<ApprovedApplicationsExportConfirmProps, object> {

    renderBody = () => {
        const {isExporting, url, fileName, hasError} = this.props;
        if (isExporting) {
            return (
                <div className="text-center py-4">
                    <LoaderIcon customClass="simple"/>
                    <p className="mt-3 mb-0">{HISTORY_EXPORT_MODAL.GENERATING_TEXT}</p>
                </div>
            );
        }
        if (hasError) {
            return <p className="text-justify mb-0">{HISTORY_EXPORT_MODAL.ERROR_TEXT}</p>;
        }
        if (url) {
            return <p className="text-justify mb-0">{HISTORY_EXPORT_MODAL.successText(fileName)}</p>;
        }
        return <p className="text-justify mb-0">{HISTORY_EXPORT_MODAL.CONFIRM_TEXT}</p>;
    }

    renderFooter = () => {
        const {isExporting, url, hasError, onConfirm, onClose} = this.props;
        if (isExporting) {
            return null;
        }
        if (hasError || url) {
            return (
                <React.Fragment>
                    {url &&
                    <button type="button"
                            className="h-auto btn btn-info rounded border-0 btn-form py-2 px-3 mr-2
                             approved-applications-export-action-btn"
                            onClick={() => window.open(url, '_blank')}>
                        {HISTORY_EXPORT_MODAL.DOWNLOAD_BUTTON}
                    </button>}
                    <button type="button"
                            className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0
                             approved-applications-export-action-btn"
                            onClick={onClose}>
                        {HISTORY_EXPORT_MODAL.CLOSE_BUTTON}
                    </button>
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                <button type="button"
                        className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0
                         approved-applications-export-action-btn"
                        onClick={onClose}>
                    {HISTORY_EXPORT_MODAL.CONFIRM_CANCEL_BUTTON}
                </button>
                <button type="button"
                        className="h-auto btn btn-link border-0 btn-form text-primary py-0 pr-0
                         approved-applications-export-action-btn"
                        onClick={onConfirm}>
                    {HISTORY_EXPORT_MODAL.CONFIRM_ACCEPT_BUTTON}
                </button>
            </React.Fragment>
        );
    }

    render() {
        return (
            <div className="col-12 p-0">
                {this.renderBody()}
                <div className="pt-3 pb-2 px-0 text-right border-top">
                    {this.renderFooter()}
                </div>
            </div>
        );
    }
}

export default ApprovedApplicationsHistoryExportConfirmView;
